import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const stockBuy: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'sbAmt' },
            { type: 'field', field: 'sbType' },
            { type: 'field', field: 'sbCompletedDate' },
            { type: 'field', field: 'sbPrice' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [
            { type: 'field', field: 'sbShares' },
            { type: 'field', field: 'sbValuePurchased' },
            { type: 'field', field: 'sbCurrency' },
        ],
    },
];

export default stockBuy;
